<template>
  <div :class="isTrial || ! isPremium ? '' : 'pa-4'" class="premium-window">
    <div v-if="! user.id" class="text-center pa-4 subheading"><i class="fas fa-spinner fa-spin fa-2x fa-fw"></i></div>
    <template v-else>
      <div v-if="isTrial || ! isPremium" class="premium-subscription-bg py-2">
        <div class="mb-6">
          <div v-if="isTrial" class="text-center pt-6 px-8 mx-auto" style="max-width: 542px">
            <div><b class="nobr">{{ $t('PREMIUM.ACCOUNT_IS_TRIAL') }} {{ $filters.moment(premiumExpireDate, 'date') }}</b></div>
            <span>{{ $t('PREMIUM.TO_CONTINUE_PREMIUM') }}</span>
          </div>
          <!-- Premium Subscription -->
          <premium-subscription @set-backdrop-close="$emit('set-backdrop-close', $event)"></premium-subscription>
        </div>
      </div>
      <div v-else-if="! isAdmin">
        <p>{{ $t('PREMIUM.ONLY_FOR_ADMIN') }}</p>
        <div class="text-center"><v-btn color="secondary" rounded large outlined @click="close">{{ $t('GLOBAL.CLOSE') }}</v-btn></div>
      </div>
      <div v-else-if="canChangeQuantity" class="mb-2">
        <b class="primary--text text-uppercase">{{ $t('PREMIUM.ADJUST_USERS_QUOTA') }}</b>
        <div class="display-flex align-center mx-auto" style="max-width: 180px">
          <v-btn color="secondary" small icon outlined @click="maxusers = maxusers - 1"><v-icon small>fas fa-minus</v-icon></v-btn>
          <v-text-field v-model.number="maxusers" type="number" :min="packageMinUsers" max="50" class="text-center"></v-text-field>
          <v-btn color="secondary" small icon outlined @click="maxusers = maxusers + 1"><v-icon small>fas fa-plus</v-icon></v-btn>
        </div>
        <div class="px-2">{{ $t('PREMIUM.WILL_PRORATE') }}</div>
        <div class="display-flex justify-space-around mt-4">
          <v-btn color="secondary" rounded large outlined @click="close">{{ $t('GLOBAL.CANCEL') }}</v-btn>
          <v-btn :disabled="saving.inprogress" color="accent" rounded large @click="adjustUsersQuota()">{{ $t('GLOBAL.VALIDATE') }}</v-btn>
        </div>
        <div class="errorred--text">{{ saving.error }}</div>
        <account-link-to-website section="premium" class="mt-8"></account-link-to-website>
      </div>
      <div v-else class="mb-2">
        <p class="pre mt-4">{{ $t('PREMIUM.CANNOT_CHANGE_PLAN') }}</p>
        <account-link-to-website section="premium" class="my-4"></account-link-to-website>
        <div class="text-center"><v-btn color="secondary" rounded large outlined @click="close">{{ $t('GLOBAL.CLOSE') }}</v-btn></div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
  .premium-window {
    .premium-subscription-bg {
      min-height: calc(100vh - 60px);

      @media (min-width: 1264px) {
        background-image: url('./img/bg-subscription.png');
        background-position-y: 50px;
        background-size: 50%;
      }
    }
  }
</style>

<script>
  import AccountLinkToWebsite from '@/components/Account/AccountLinkToWebsite';
  import PremiumSubscription from './PremiumSubscription';

  export default {
    components: {
      AccountLinkToWebsite,
      PremiumSubscription,
    },
    data() {
      return {
        maxusers: null,
        packageMinUsers: 1,
        saving: { inprogress: false, error: "" },
      };
    },
    computed: {
      canChangeQuantity() {
        return this.package == 'TEAM' || this.package == 'TEAM12M' || this.package == 'BUSINESS' || this.package == 'BUSINESS12M';
      },
      premiumExpireDate() {
        return this.user.company.premiumExpireDate;
      },
      user() { return this.$store.state.users.user; },
      package() { return this.user.company && this.user.company.billing_plan; },
      isAdmin() { return this.$store.state.users.accessRight.isAdmin; },
      isPremium() { return this.$store.state.users.accessRight.isPremium; },
      isTrial() { return this.$store.state.users.accessRight.isTrial; },
    },
    watch: {
      maxusers(newVal) {
        if (newVal < this.packageMinUsers) this.$nextTick(() => { this.maxusers = this.packageMinUsers; });
        if (newVal > 50) this.$nextTick(() => { this.maxusers = 50; });
      },
    },
    created() {
      this.$store.state.users.userPromise.then(() => {
        this.maxusers = this.user.company && this.user.company.maxusers;
      });
    },
    methods: {
      adjustUsersQuota() {
        this.saving = { inprogress: true, error: "" };
        window.apiSrv.call('buy/plan/quantity', 'update', { id: this.maxusers }).then(() => {
          this.close();
          window.location.reload();
        }).catch((message) => {
          this.saving = { inprogress: false, error: `Error : ${message}` };
        });
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
